<div
  class="bg-white w-full flex-1 flex flex-col items-center justify-center space-y-2 rounded-md border border-gray-200 p-10"
>
  <span class="material-icons-outlined text-primary text-5xl">inventory_2</span>
  <span class="text-md font-semibold text-primary">{{ title }}</span>
</div>
